module.exports = __webpack_public_path__ + "static/scale-model-of-springs-bike-tours-in-colorado-springs-colorado-6f5bc59eecd850a795570c1ec1549e7d.png";